import { ISimpleTableField } from "@asup/simple-table";
import { eHierarchyLevel } from "../../../../functions/api/enums";
import { SearchResultsHeaders, SearchTocHeaders } from "./searchResultsHeaders";
import { templateHeaders } from "./templateHeaders";
import { TocHeaders } from "./tocHeaders";

/**
 * Returns appropriate table header configuration based on display mode and hierarchy level.
 *
 * @param showSearchResults - Whether displaying general search results
 * @param showTocSearchResults - Whether displaying TOC search results
 * @param hierarchyLevel - Current hierarchy level
 */
export const getTemplateHeaders = (
  showSearchResults: boolean,
  showTocSearchResults: boolean,
  hierarchyLevel: eHierarchyLevel,
): ISimpleTableField[] =>
  showSearchResults
    ? SearchResultsHeaders
    : showTocSearchResults
      ? SearchTocHeaders
      : hierarchyLevel === eHierarchyLevel.Report
        ? TocHeaders
        : hierarchyLevel !== eHierarchyLevel.Corporate
          ? templateHeaders.filter((h) => h.name !== "taVersionsAvailable")
          : templateHeaders;
